import Controller from "csi/action/Controller";
import localeProvider from "csi/page/localeProvider";
import { featureTogglesStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";
import { BaseCompositionStore } from "./BaseCompositionStore";
import { resolveNodes, resolveNodesWithDependencies } from "csi/service/nodeService";

const BaseCompositionActionController = declare(Controller, {

	/** @property {boolean} fromStyleBom - true if from Style BOM */
	fromStyleBom: false,

	/** @property {boolean} dialogCalledFromEdit - true if from Edit */
	dialogCalledFromEdit: false,

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { dialogCalledFromEdit, fromStyleBom, m_cache } = this;
		const compositionFeatureFlagEnabled = featureTogglesStore.MATERIAL_COMPOSITION;
		const cnCSalesRegion = m_cache.get(this.m_urlNode);
		const currentSREURL = cnCSalesRegion?.SalesRegion;
		const curentSRE = m_cache.get(currentSREURL);

		const careCompRevNode = this.getParent();
		const careCompNode = m_cache.get(careCompRevNode.__Parent__);
		const styleCNL = careCompNode.__Parent__;
		const careCompRevCNL = careCompRevNode.$URL;
		const productSalesRegions = m_cache.get(styleCNL).ProductSalesRegions;
		const promises = [resolveNodes(productSalesRegions, m_cache)];
		if (dialogCalledFromEdit) {
			const p = resolveNodesWithDependencies([careCompRevCNL], [
				"Child:Items/Child:TechnicalComposition", 
				"Child:Items/Child:CareAndCompositionLines/Child:TechnicalComposition",
				"Child:SalesRegionException/Child:SalesRegionItems/Child:TechnicalComposition",
				"Child:SalesRegionException/Child:SalesRegionItems/Child:CareAndCompositionLines/Child:TechnicalComposition",
			], m_cache);
			promises.push(p);
		}
		await Promise.all(promises);

		props.store = new BaseCompositionStore(
			dialogCalledFromEdit,
			curentSRE?.$Name,
			localeProvider,
			props.onSave,
			props.onClose,
			compositionFeatureFlagEnabled,
			fromStyleBom,
			careCompRevNode,
			productSalesRegions.map((sr) => m_cache.get(sr)),
			m_cache,
		);
	},
});
export = BaseCompositionActionController;